import { render, staticRenderFns } from "./notificationsLink.vue?vue&type=template&id=65fc2a24&scoped=true&"
import script from "./notificationsLink.vue?vue&type=script&lang=js&"
export * from "./notificationsLink.vue?vue&type=script&lang=js&"
import style0 from "./notificationsLink.vue?vue&type=style&index=0&id=65fc2a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc2a24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65fc2a24')) {
      api.createRecord('65fc2a24', component.options)
    } else {
      api.reload('65fc2a24', component.options)
    }
    module.hot.accept("./notificationsLink.vue?vue&type=template&id=65fc2a24&scoped=true&", function () {
      api.rerender('65fc2a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/notificationsLink.vue"
export default component.exports